import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">观众热评</h2>
          <div className="w-12 h-1 bg-accent-500 mx-auto rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {commentsData.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl p-5 border border-background-200/70 flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">{item.comment}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes.toLocaleString()} 人觉得有用</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}